import { PaymentChoice } from "@/components/PaymentChoice";
import { GiftCodeField } from "@/components/GiftCodeField";
import { ModePaiement } from "@/components/ModePaiement";

const inputCls = "w-full bg-white/60 border border-wood/25 rounded-xl px-4 py-3 text-base sm:text-sm focus:outline-none focus:border-terra";

export const ContactFields = ({ contact, onChange }) => {
  const set = (key) => (e) => onChange({ ...contact, [key]: e.target.value });
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      <label className="sm:col-span-2"><span className="eyebrow block mb-2 !text-bark">Nom et prénom</span><input required autoComplete="name" value={contact.nom} onChange={set("nom")} data-testid="stage-contact-nom" className={inputCls} /></label>
      <label><span className="eyebrow block mb-2 !text-bark">E-mail</span><input required type="email" autoComplete="email" value={contact.email} onChange={set("email")} data-testid="stage-contact-email" className={inputCls} /></label>
      <label><span className="eyebrow block mb-2 !text-bark">Téléphone</span><input required type="tel" autoComplete="tel" minLength={6} value={contact.telephone} onChange={set("telephone")} data-testid="stage-contact-telephone" className={inputCls} /></label>
      <label className="sm:col-span-2"><span className="eyebrow block mb-2 !text-bark">Message (facultatif)</span><textarea rows={2} value={contact.message} onChange={set("message")} data-testid="stage-contact-message" className={`${inputCls} resize-none`} /></label>
    </div>
  );
};

export const PaymentFields = ({ pay, onPay, carte, onCarte, du }) => (
  <div className="space-y-4" data-testid="stage-payment">
    <PaymentChoice compact value={pay.paiement} onChange={(paiement) => onPay((p) => ({ ...p, paiement }))} testidPrefix="stage" />
    <GiftCodeField carte={carte} onChange={onCarte} testidPrefix="stage" />
    {pay.paiement === "en_ligne" && <ModePaiement value={pay.mode_paiement} onChange={(mode_paiement) => onPay((p) => ({ ...p, mode_paiement }))} total={du} testidPrefix="stage" />}
  </div>
);
